import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';
import {
  PageTitleAndSubTitle,
  OverviewCard as OverViewCard,
  GeographicDistributionChart,
  FemaleToMaleRatioChart,
  EnrollmentHealthCareChart,
  PlanDistributionChart,
  MemberTable,
  Breadcrumbs,
  MultiStackedColumnChart,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';

import enrollmentMetricsMessages from '../../core-utils/messages/enrollmentMetricsMessages';
import axios from 'axios';
import Loader from '../../_components/molecules/Loader';
import {
  EnrollmentChartFormat,
  EnrollmentMetricsAPIResponse,
  FemaleToMaleAPIResponse,
  formatEnrollmentAnalysis,
  MemberTableDataAPIResponse,
  PlanDistributionAPIResponse,
} from '../../core-utils/helper-utils/enrollmentMetricsHelpers';
import properties from '../../core-utils/properties';
import {
  formatPEPM,
  formatPMPM,
  formatTotalCost,
  formatTotalEnrolled,
  getPepmForCohorts,
  getPepmValueForCohorts,
  getPmpmForCohorts,
  getPmpmValueForCohorts,
  PEPM,
  PMPM,
  TotalCost,
  TotalEnrolled,
} from '../../core-utils/helper-utils/summaryReportHelper';
import { useStores } from '../../stores';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import ReportsModal from '../../_components/organisms/ReportsModal';
import { useNavigate, useLocation } from 'react-router-dom';
import { PLAN_PERFORMANCE } from '../../core-utils/routes';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import EmptyData from '../../_components/atoms/Icons/EmptyData';
import { CardComponent } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { observer } from 'mobx-react';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { getCohortMembersCount } from '../../core-utils/axios/Cohort/Summary';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';

const EnrollmentMetricsPage = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      backgroundColor: '',
      border: '',
      marginTop: '40px',
      marginLeft: '63px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '36px',
      marginBottom: '28px',
    },
    OverViewCardMargin: {
      marginRight: '24px',
    },
    GridItem: {
      marginBottom: '27px',
      display: 'inline-block',
    },
    emptyDataIconGrid: {
      marginTop: '80px',
      marginBottom: '20px',
    },
  });
  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const colors = ['#2B376A', '#6C7DC0', '#919DD0', '#B5BEDF', '#E5E9F0'];
  //State Variables
  const [loading, setLoading] = useState<boolean>(false);
  const [enrollmentAnalysis, setEnrollmentAnalysis] = useState<any>();
  const [
    femaleToMaleRatio,
    setFemaleToMaleRatio,
  ] = useState<FemaleToMaleAPIResponse>();
  const [memberTableResponse, setMemberTableResponse] = useState<
    MemberTableDataAPIResponse[]
  >();
  const [
    memberTableDependentResponse,
    setMemberTableDependentResponse,
  ] = useState<MemberTableDataAPIResponse[]>();
  const [geographicStateData, setGeographicStateData] = useState<any[]>();
  const [geographicCountyData, setGeographicCountyData] = useState<any[]>();
  const [enrollmentHealthCareData, setEnrollmentHealthCareData] = useState<
    EnrollmentMetricsAPIResponse[]
  >();

  const [planDistributionData, setPlanDistributionDate] = useState<
    PlanDistributionAPIResponse[]
  >();
  const [toggleState, setSelectedToggle] = useState<'left' | 'right'>('left');
  const navigate = useNavigate();
  const location = useLocation();
  const { open, openModal, closeModal, isEditMode } = useCohortModal();
  // const loginPageStore = useStores().loginPageStore;

  //Enrollment Cards--
  //Summary cards states and api call functions
  const [totalEnrolled, setTotalEnrolled] = useState<TotalEnrolled>({
    dependents: '',
    totalCount: '',
    employees: '',
  });
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  const [pmpm, setPMPM] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });
  const [pepm, setPEPM] = useState<PEPM>({
    pepm: '',
    pepmPercentage: '',
    increment: true,
  });
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const screenName = allScreenLabel;
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };
  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        enrollmentMetricsMessages.pageTitles.title,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const getTotalEligible = async () => {
    await axios
      .post(
        properties.aiqBaseUrl + properties.summaryBaseUrl,
        {
          ...payload,
          claim_id_list: [],
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setTotalEnrolled(formatTotalEnrolled(res?.data?.data));
          setTotalCost(formatTotalCost(res?.data?.data));
        }
      })
      .catch((error) => {
        return error;
      });
  };

  const getPMPMAndPepm = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pmpmAndPepm,
        {
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        { signal: abortController.signal },
      )
      .then((res) => {
        if (res?.status === 200) {
          setPMPM(formatPMPM(res?.data?.data?.pmpm));
          setPEPM(formatPEPM(res?.data?.data?.pepm));
        }
      })
      .catch((error) => {
        return error;
      });
  };

  // Edit duration related states and functions

  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    employerGroupStore,
    loginPageStore,
    cohortDetailsStore,
  } = useStores();
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;
  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCohortMembersCount(
        employerGroupStore.employerGroupResponseData.eg_nid,
        aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
        employerGroupStore.employerGroupResponseData.max_claim_date,
      ),
    enabled:
      isPlanDatesFetched &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const abortController = new AbortController();
  const payload = useAPIPayload();

  //API Calls -
  //API Call for Female to Male Ratio Chart.
  const getFemaleToMaleRatio = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.enrollmentPageBaseUrl +
      properties.femaleToMaleRatio;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid, //NEED TO CHECK
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          setFemaleToMaleRatio(res.data?.data);
        }
      })
      .catch(() => {});
  };

  const getMemberEnrollmentAnalysis = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.enrollmentPageBaseUrl +
      properties.enrollmentAnalysis;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal }) //NEED TO CHECK
      .then((res) => {
        if (res) {
          setEnrollmentAnalysis(formatEnrollmentAnalysis(res.data.data));
        }
      })
      .catch(() => {});
  };

  //API call to get the data for Employees in the member table
  const getMembersTable = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.enrollmentPageBaseUrl +
      properties.membersData;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      role: 'Employee',
      claim_id_list: [],
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          const data = res.data?.data;
          data.forEach(function (obj: any) {
            if (obj.age_group === 'no_data') {
              obj.age_group = 'No Data';
            }
          });
          setMemberTableResponse(data);
        }
      })
      .catch(() => {});
  };

  const getMembersTableForDependent = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.enrollmentPageBaseUrl +
      properties.membersData;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      role: 'Dependent',
      claim_id_list: [],
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList || [],
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          const data = res.data?.data;
          data.forEach(function (obj: any) {
            if (obj.age_group === 'no_data') {
              obj.age_group = 'No Data';
            }
          });
          setMemberTableDependentResponse(data);
        }
      })
      .catch(() => {});
  };

  //API call for Geographic data (state View)
  const getGeographicData = async (mapType: String) => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.enrollmentPageBaseUrl +
      properties.geographicData;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      map_type: mapType,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          mapType === 'state'
            ? setGeographicStateData(res.data.data)
            : setGeographicCountyData(res.data.data);
        }
      })
      .catch(() => {});
  };

  //API Call for Enrollments HealthCare Chart.
  const getEnrollmentsHealthCare = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.enrollmentPageBaseUrl +
      properties.enrollmentHealthCare;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          setEnrollmentHealthCareData(res.data.data);
        }
      })
      .catch(() => {});
  };

  //API Call for Plan Distribution Donut chart
  const getPlanDistribution = async () => {
    const baseUrl =
      properties.aiqBaseUrl +
      properties.enrollmentPageBaseUrl +
      properties.planDistribution;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
      member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          setPlanDistributionDate(res.data.data);
        }
      })
      .catch(() => {});
  };

  //data-preparation:
  const getDataForFemaleToMaleRatio = () => {
    const resultData: any[] = femaleToMaleRatio
      ? [
          {
            femaleValue: femaleToMaleRatio!['0-18']?.femaleCount,
            maleValue: femaleToMaleRatio!['0-18']?.maleCount,
            label: '0-18',
          },
          {
            femaleValue: femaleToMaleRatio!['19-26']?.femaleCount,
            maleValue: femaleToMaleRatio!['19-26']?.maleCount,
            label: '19-26',
          },
          {
            femaleValue: femaleToMaleRatio!['27-40']?.femaleCount,
            maleValue: femaleToMaleRatio!['27-40']?.maleCount,
            label: '27-40',
          },
          {
            femaleValue: femaleToMaleRatio!['41-64']?.femaleCount,
            maleValue: femaleToMaleRatio!['41-64']?.maleCount,
            label: '41-64',
          },
          {
            femaleValue: femaleToMaleRatio!['65+']?.femaleCount,
            maleValue: femaleToMaleRatio!['65+']?.maleCount,
            label: '65+',
          },
        ]
      : [];
    return resultData;
  };

  const getDataForTable = () => {
     
    let returnData: any = [
      [
        '',
        { box1: 'Male', Box2: 'Female' },
        { box1: 'Male', Box2: 'Female' },
        { box1: 'Male', Box2: 'Female' },
        { box1: 'Male', Box2: 'Female' },
      ],
    ];
    const tableResponse =
      toggleState === 'left'
        ? memberTableResponse
        : memberTableDependentResponse;

    tableResponse
      ?.filter((ele) => ele.gender === 'M' || ele.gender === 'F')
      .forEach((element, index) => {
         
        if (index % 2 == 0) {
          const rowData = [];
          const ageGroup = element.age_group;
          const claimants = {
            box1: tableResponse[index + 1]?.count,
            Box2: element.count,
          };
          const planPaid = {
            box1: tableResponse[index + 1]?.total_plan_paid,
            Box2: element.total_plan_paid,
          };
          const avg_paid = {
            box1: tableResponse[index + 1]?.avg_paid,
            Box2: element.avg_paid,
          };
          const pmpm = {
            box1: tableResponse[index + 1]?.pmpm,
            Box2: element.pmpm,
          };
          rowData.push(ageGroup, claimants, planPaid, avg_paid, pmpm);
          returnData.push(rowData);
        }
      });
    return returnData;
  };

  const getDataForGeographicState = () => {
    const returnData: any[] = [];
    geographicStateData?.forEach((element) => {
      const object = {
        id: element.state,
        value: element.membersCount,
      };
      returnData.push(object);
    });
    return returnData;
  };

  const getDataForGeographicCounty = () => {
    const returnData: any[] = [];
    geographicCountyData?.forEach((element) => {
      const object = {
        id: element.county,
        value: element.membersCount,
      };
      returnData.push(object);
    });
    return returnData;
  };

  const getDataForEnrollmentHealthCareChart = () => {
    const returnData: EnrollmentChartFormat[] = [];
    let allZero = true;
    enrollmentHealthCareData?.forEach((element) => {
      const obj = {
        label: element.subscriptionType,
        value: String(element.count),
      };
      if (element?.count > 0) {
        allZero = false;
      }
      returnData.push(obj);
    });

    return allZero ? [] : returnData;
  };

  // TO get the data for Plan distribution Chart - FIX styling issue
   
  const getPlanDistributionData = () => {
    const colors = ['#00BDA5', '#F5C26B', '#FF8E59', '#919DD0'];
    const returnData: any[] = [];
    planDistributionData?.forEach((element, index) => {
      const obj = {
        label: element.plan_name,
        value: element.total_members_count,
        color: colors[index],
      };
      returnData.push(obj);
    });
    return returnData;
  };

  const recommendedTabStore = useStores().recommendedTabStore;

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      const cleanData = {
        title_1: {
          totalEnrolled,
          totalCost,
          pmpm,
          pepm,
        },

        title_2: femaleToMaleRatio,

        title_3: enrollmentAnalysis,

        title_4: memberTableResponse,

        title_5: memberTableDependentResponse,

        title_6: geographicStateData,

        title_7: geographicCountyData,

        title_8: enrollmentHealthCareData,

        title_9: planDistributionData,
      };

      let resultArray = [];

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.ENROLLMENT_METRICS,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: cleanData,
          },
        );

        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
        console.error('AI Summary API failed:', apiError);
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error) {
      console.error('Unexpected Error:', error);
      handleOpenSnackBar(
        'Something went wrong. Please try again.',
        'error',
        6000,
      );
      setAiSummaryData([]);
    } finally {
      setAiLoading(false);
    }
  };

  const apiCalls = async () => {
    setLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        getTotalEligible(),
        getPMPMAndPepm(),
        getFemaleToMaleRatio(),
        getMembersTable(),
        getGeographicData('state'),
        getGeographicData('county'),
        getEnrollmentsHealthCare(),
        getPlanDistribution(),
        getMemberEnrollmentAnalysis(),
      ]).then(() => {
        getMembersTableForDependent();
        setLoading(false);
      }));

    setLoading(false);
  };

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    apiCalls();
    return () => {
      abortController.abort();
    };
  }, [
    isInitializing,
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    cohortDetailsStore.conditionsDetails,
  ]);
  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  //click Here Navigation Functions -

  const pushToPlanPerformance = () => {
    navigate(PLAN_PERFORMANCE);
  };

  const EnrollmentAnalysis = () => {
    return (
      <Box className={classes.flexContainer}>
        <Box className={classes.OverViewCardMargin}>
          <OverViewCard
            title={enrollmentMetricsMessages.cardText.totalEnrolled}
            value={totalEnrolled.totalCount}
            isMultiValued={true}
            rightLabelValues={[
              [
                enrollmentMetricsMessages.cardText.employees,
                String(totalEnrolled.employees),
              ],
              [
                enrollmentMetricsMessages.cardText.dependents,
                String(totalEnrolled.dependents),
              ],
            ]}
            rootStyles={{
              width: 'auto',
            }}
            labelsMinWidth={'72px'}
          />
        </Box>

        <Box className={classes.OverViewCardMargin}>
          <OverViewCard
            title={enrollmentMetricsMessages.cardText.totalCost}
            value={totalCost.totalCost}
            isMultiValued={true}
            rightLabelValues={[
              [
                enrollmentMetricsMessages.cardText.medical,
                totalCost?.totalMedical,
              ],
              [enrollmentMetricsMessages.cardText.rx, totalCost?.totalRx],
            ]}
            rootStyles={{
              width: '276px',
            }}
            showClickHere
            handleClickHere={pushToPlanPerformance}
          />
        </Box>
        <Box className={classes.OverViewCardMargin}>
          <OverViewCard
            title={enrollmentMetricsMessages.cardText.pmpm}
            topLabelValues={getPmpmForCohorts(pmpm, [], [])}
            value={getPmpmValueForCohorts(pmpm, [], [])}
            rootStyles={{
              width: '176px',
            }}
            showClickHere
            handleClickHere={pushToPlanPerformance}
          />
        </Box>
        <Box className={classes.OverViewCardMargin}>
          <OverViewCard
            title={enrollmentMetricsMessages.cardText.pepm}
            topLabelValues={getPepmForCohorts(pepm, [], [])}
            value={getPepmValueForCohorts(pepm, [], [])}
            rootStyles={{
              width: '176px',
            }}
            showClickHere
            handleClickHere={pushToPlanPerformance}
          />
        </Box>
      </Box>
    );
  };

  const [loader] = useState<any>(<Loader />);
  const pathStore = useStores().pathStore;
  const getPath = () => {
    if (location.state !== undefined) {
      return [
        [
          'text',
          'Go Back',
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
          () => {
            navigate(-1);
          },
        ],
      ];
    }
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };

  return isPlanDatesLoading || loading || isInitializing ? (
    loader
  ) : (
    <Box className={classes.mainDiv}>
      {getPath().length !== 0 && (
        <Box style={{ marginBottom: '20px' }}>
          <Breadcrumbs itemList={getPath()} />
        </Box>
      )}
      <>
        <Box style={{ width: '1182px', position: 'relative' }}>
          <PageTitleAndSubTitle
            title={enrollmentMetricsMessages.pageTitles.title}
            subTitle={enrollmentMetricsMessages.pageTitles.subtitle}
            showDownloadButton={true}
            // downloadButtonAction={() => setOpenReportsModal(true)}
            downloadButtonAction={() => {
              downloadPdf(
                'enrollmentReport',
                {
                  employer:
                    employerGroupStore?.employerGroupResponseData
                      ?.employer_group_name,
                  member_unique_id_list:
                    cohortDetailsStore.memberUniqueIdList || [],
                  claim_id_list: [],
                  maxClaimDate:
                    employerGroupStore?.employerGroupResponseData
                      ?.max_claim_date,
                  ...payload,
                },
                handleOpenSnackBar,
                'open',
              );
              handleOpenSnackBar(
                snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                'info',
                6000,
              );
            }}
            // showQueryDataButton={checkUserAccess(
            //   UserAccessConstants.COHORT_DETAILS,
            //   loginPageStore.userResponse.role.name,
            //   loginPageStore.userFeatures,
            // )}
            showAskAi={true}
            askAiAction={handleAskAi}
            showQueryDataButton={checkUserAccess(
              UserAccessConstants.COHORT_DETAILS,
              loginPageStore.userResponse.role.name,
              loginPageStore.userFeatures,
            )}
            queryButtonText={
              cohortDetailsStore.cohortDetailsList?.length > 0 &&
              cohortDetailsStore.cohortDetailsList[0].category !== ''
                ? 'Edit Cohort'
                : 'Add Cohort'
            }
            queryDataAction={() => {
              if (
                checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )
              ) {
                openModal();
              }
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '-2px',
              left: '166px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <Typography
              fontSize="17px"
              lineHeight="21px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              fontType="semiBold"
              margin="0px 8px"
            >
              {COMMON_TEXTS.FOR}
            </Typography>
            <DateFilter />
          </div>

          <TabSelection
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={handleSelectedIndex}
            recommendationFetched={recommendationFetched}
          />
          <CohortFilterBar />
        </Box>
      </>

      <Box>
        {selectedTabIndex === 0 && (
          <>
            <EnrollmentAnalysis />
            {/* Charts */}
            <Box>
              <Box style={{ marginRight: '24px' }} className={classes.GridItem}>
                <GeographicDistributionChart
                  statesData={getDataForGeographicState()}
                  countiesData={getDataForGeographicCounty()}
                  mapColors={[
                    {
                      minvalue: '0',
                      maxvalue: '20',
                      displayValue: '0-20',
                      code: patientAccessTheme.palette.primary[100],
                    },
                    {
                      minvalue: '20',
                      maxvalue: '65',
                      code: patientAccessTheme.palette.primary[200],
                    },
                    {
                      minvalue: '65',
                      // maxvalue: '120',
                      displayValue: '>65',
                      code: patientAccessTheme.palette.primary[300],
                    },
                  ]}
                />
              </Box>
              <Box className={classes.GridItem}>
                <FemaleToMaleRatioChart data={getDataForFemaleToMaleRatio()} />
              </Box>
              <br />
              <Box style={{ marginRight: '24px' }} className={classes.GridItem}>
                {getDataForEnrollmentHealthCareChart()?.length === 0 ? (
                  <CardComponent
                    title={
                      enrollmentMetricsMessages.enrollmentHealthCareChart.TITLE
                    }
                    subTitle={
                      enrollmentMetricsMessages.enrollmentHealthCareChart
                        .SUBTITLE
                    }
                    body={
                      <Grid
                        container
                        sx={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'column',
                        }}
                      >
                        <Grid className={classes.emptyDataIconGrid}>
                          <EmptyData />
                        </Grid>
                        <Grid>
                          <Typography
                            fontSize="14px"
                            fontType="regular"
                            lineHeight="24.78px"
                            textColor={
                              patientAccessTheme.palette.text.mediumemphasis
                            }
                          >
                            {
                              enrollmentMetricsMessages
                                .enrollmentHealthCareChart.emptyText
                            }
                          </Typography>
                        </Grid>
                      </Grid>
                    }
                    height="467px"
                    width="576px"
                  />
                ) : (
                  <EnrollmentHealthCareChart
                    chartData={getDataForEnrollmentHealthCareChart()}
                    title={
                      enrollmentMetricsMessages.enrollmentHealthCareChart
                        .ENROLLMENT.TITLE
                    }
                    subtitle={
                      enrollmentMetricsMessages.enrollmentHealthCareChart
                        .ENROLLMENT.SUBTITLE
                    }
                  />
                )}
              </Box>

              <Box className={classes.GridItem}>
                <PlanDistributionChart
                  // TODO- uncomment to fetch data from api , style changes required.
                  data={getPlanDistributionData()}
                  centerLabel={'100%'}
                  isEnrollmentPage={true}
                />
              </Box>
              <br />

              <Box className={classes.GridItem}>
                <MultiStackedColumnChart
                  title="Member Enrollment Trend by Enrollment Type"
                  subTitle="This visual shows the trend of number of members enrolled by enrollment type in each month for the selected period"
                  widthOfCard="1175px"
                  widthOfChart={1000}
                  heightOfChart={290}
                  heightOfCard="383px"
                  category={enrollmentAnalysis?.xAxisValues}
                  dataSet={[
                    {
                      dataset: enrollmentAnalysis?.data?.map(
                        (item: any, index: number) => {
                          return {
                            seriesname: item.subscription_type,
                            color: colors[index],
                            data: item.values,
                          };
                        },
                      ),
                    },
                  ]}
                  xAxisLabel="Member Count"
                  numberPrefix={''}
                />
              </Box>

              <Box className={classes.GridItem}>
                <MemberTable
                  memberData={getDataForTable()}
                  setSelectedToggle={setSelectedToggle}
                />
              </Box>
            </Box>
          </>
        )}
        {selectedTabIndex === 1 && (
          <div style={{ height: '493px', padding: '20px' }}>
            <RecommendationsTab
              recommendationLoading={recommendationLoading}
              isInternalPage={true}
            />
          </div>
        )}
      </Box>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData || []}
        loading={aiLoading}
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
      />
    </Box>
  );
});

export default EnrollmentMetricsPage;
